export const businessAddress = "6227 White Horse Rd, Greenville, SC 29611, USA";
export const businessPhoneNumber1 = "+19189342685";
export const businessPhoneNumber2 = "+18649065765";
